// Loads /assets/settings.json at runtime (works under subpaths too)

export type AppConfig = {
  CLIENT_ID: string;
  AUTHORITY: string;
  REDIRECT_URI: string;
  API_URL: string;        // "/" or absolute
  CLIENT_SCOPE: string;
  assetsVersion?: string; // optional cache-bust knob
};

export async function loadConfig(): Promise<AppConfig> {
  const base = import.meta.env.BASE_URL ?? "/";
  const originBase = window.location.origin + (base.endsWith("/") ? base : base + "/");
  const url = new URL("assets/settings.json", originBase).toString();

  // Cache-bust to avoid stale responses (SW/CDN)
  const res = await fetch(url + `?v=${Date.now()}`, { cache: "no-store" });
  if (!res.ok) {
    throw new Error(`Failed to load settings.json: ${res.status} ${res.statusText} at ${url}`);
  }
  const cfg = (await res.json()) as AppConfig;

  // minimal sanity
  if (!cfg.CLIENT_ID || !cfg.AUTHORITY || !cfg.REDIRECT_URI) {
    console.warn("settings.json seems incomplete:", cfg);
  }
  return cfg;
}
